import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import type { MenuProps } from 'antd';

const { Text } = Typography;

interface UserDropdownProps {
  email: string;
  name: string;
  role: string;
  onLogout: () => void;
}

/**
 * Dumb component — displays current user info and logout action.
 * Receives all data via props; no store access.
 */
export default function UserDropdown({ email, name, role, onLogout }: UserDropdownProps) {
  const { t } = useTranslation('common');

  const menuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <div style={{ padding: '4px 0', pointerEvents: 'none' }}>
          <div>
            <Text strong>{name}</Text>
          </div>
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {role}
            </Text>
          </div>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('navigation.logout'),
      danger: true,
      onClick: onLogout,
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
      <Space
        style={{ cursor: 'pointer', padding: '0 8px' }}
        role="button"
        aria-label={`${t('user.profile')}: ${email}`}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.currentTarget.click();
          }
        }}
      >
        <Avatar
          icon={<UserOutlined />}
          style={{ backgroundColor: '#1677ff' }}
          size="small"
        />
        <Text
          style={{
            maxWidth: 160,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {email}
        </Text>
      </Space>
    </Dropdown>
  );
}
